var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__wrapper" }, [
    _c("div", { staticClass: "header" }, [
      _c("h1", { attrs: { id: "logo" } }, [
        _c(
          "a",
          { attrs: { href: "/" } },
          [
            _c("app-icon", { attrs: { type: "iconlogo1" } }),
            _vm._v(" "),
            _c("b", [_vm._v("采讯")])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "top-nav" },
        [
          _c(
            "a",
            {
              staticClass: "app-store",
              attrs: { href: "https://app.zcygov.cn", target: "_blank" }
            },
            [_vm._v("应用市场")]
          ),
          _vm._v(" "),
          _c("zcy-modal")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-613e5ae0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613e5ae0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/index.vue
// module id = Bbu9
// module chunks = 1 2